const dronesFiltersTypes = (state = [], action) => {
  switch (action.type) {
    case 'SET_DRONE_FILTER_TYPES':
      return action.payload;
    default:
      return state;
  }
};

export default dronesFiltersTypes;
